import React from "react";
import {
  Grid,
  Button,
  MenuItem,
  Select,
  TextField,
  Stack,
  Typography,
} from "@mui/material";
import CustomExpandMore from "../../../../../common/CustomExpandMore";
import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";
import { useStyles } from "../../styles";
import useCourse from "../../../../../Hooks/course";
import useSemester from "../../../../../Hooks/semester";
import useSubject from "../../../../../Hooks/subject";
import { useLocation, useNavigate } from "react-router-dom";
import { color } from "../../../../../assets/const/color";
import Loader from "../../../../../common/Loader";
import moment from "moment";
import useAuthStore from "../../../../../Hooks/auth";
import { setRedirect } from "../../../../../store/assignment";
import { scrolltoView } from "../../../../../Utils/scrollToView";

const current = moment(new Date()).format("YYYY");

const SubjectSchema = Yup.object().shape({
  idCourse: Yup.string().required("* Please select Course"),
  name: Yup.string().required("* Please enter Subject Name"),
  // year: Yup.number()
  //   .test(
  //     "len",
  //     "* Must be exactly 4 characters",
  //     (val) => val && val.toString().length === 4
  //   )
  //   .max(new Date().getFullYear()).required("* Please enter the year"),
  year: Yup.number()
    .integer()
    .min(2000, "* Year must be greater then 2000")
    .max(2100, "* Year must be less then 2100")
    .required("* Please enter year"),
  idSemester: Yup.string().required("* Please select Semester"),
  description: Yup.string().required("* Please enter the description"),
});

const AddEditSubject = () => {
  const classes = useStyles();
  const location = useLocation();
  const { getAllCourseAction, courseData } = useCourse();
  const { getSemesterAction, semesterData } = useSemester();
  const { addSubjectAction, subjectData, updateSubjectAction, loading } =
    useSubject();
  const {institutionId} = useAuthStore()
  const id = location?.state?.id;

  const navigate = useNavigate();

  const activeData = subjectData?.subject?.findIndex((_el) => _el.id === id);
  //console.log("activeData", subjectData[activeData], id);

  const AddEditSubject = {
    idCourse: subjectData?.subject?.[activeData]?.idCourse || "",
    name: subjectData?.subject?.[activeData]?.name || "",
    idSemester: subjectData?.subject?.[activeData]?.idSemester || "",
    year: subjectData?.subject?.[activeData]?.year || current,
    description: subjectData?.subject?.[activeData]?.description || "",
  };
  // const initValues = {
  //   idCourse: "",
  //   year: current,
  //   name: "",
  //   idSemester: "",
  //   description: "",
  // };

  React.useEffect(() => {
    getAllCourseAction({
      course: {
        limit: 10,
        offSet: 0,
        institutionId
      },
    });
    getSemesterAction({ limit: 50, offSet: 0 ,institutionId});
  }, []);

  React.useEffect(()=>{
    scrolltoView(`#updatesubject`);

  },[]);

  const handleClick = () =>{
    setTimeout(() => {
      navigate(-1)
    }, 3000); 
  }


  return (
    <>
      {loading && <Loader />}
      <Grid container sx={{ p: 3 }} className={classes.semesterList}>
        <Grid item lg={10} sm={12}>
          <Stack className={classes.align}>
            <Formik
              validationSchema={SubjectSchema}
              initialValues={AddEditSubject}
              validateOnBlur={false}
              validateOnChange={false}
              onSubmit={(values) => {
                //console.log("values", values);
                if (id) {
                  updateSubjectAction({ ...values, id: id });
                  setRedirect(true)

                } else {
                  addSubjectAction(values);
                  setRedirect(true)
                }
              }}
            >
              {(formik) => {
                const { errors, touched, handleChange, handleSubmit, values } =
                  formik;
                return (
                  <form onSubmit={handleSubmit}>
                    <Grid className={classes.formView}>
                      <Stack
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        <Stack
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "row",
                          }}
                        >
                          <Stack sx={{ minWidth: "150px" }}>
                            <Typography id="updatesubject" className={classes.input_label}>
                              Course
                            </Typography>
                          </Stack>
                          <Stack>
                            <Select
                              id="idCourse"
                              name="idCourse"
                              placeholder="Enter course"
                              onChange={handleChange}
                              value={values.idCourse}
                              className={
                                errors.idCourse && touched.idCourse
                                  ? classes.inputError
                                  : classes.inputNoError
                              }
                              IconComponent={CustomExpandMore}
                              sx={{
                                width: 220,
                              }}
                              displayEmpty
                            >
                              <MenuItem value="" disabled>
                                Select Course
                              </MenuItem>
                              {courseData &&
                                courseData?.course?.map((_el, index) => (
                                  <MenuItem value={_el.id} key={index}>
                                    {_el.name}
                                  </MenuItem>
                                ))}
                            </Select>
                            <ErrorMessage
                              name="idCourse"
                              component="span"
                              className={classes.error}
                            />
                          </Stack>
                        </Stack>
                        <Stack
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "row",
                            ml: 1,
                          }}
                        >
                          <Stack sx={{ minWidth: "150px" }}>
                            <Typography className={classes.input_label}>
                              Subject
                            </Typography>
                          </Stack>
                          <Stack>
                            <TextField
                              id="name"
                              name="name"
                              placeholder="Enter name"
                              sx={{
                                width: 220,
                              }}
                              className={
                                errors.name && touched.name
                                  ? classes.inputError
                                  : classes.inputNoError
                              }
                              onChange={handleChange}
                              value={values.name}
                            />
                            <ErrorMessage
                              name="name"
                              component="span"
                              className={classes.error}
                            />
                          </Stack>
                        </Stack>
                      </Stack>
                    </Grid>
                    <Grid className={classes.formView} sx={{ my: 2 }}>
                      <Stack
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        <Stack
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "row",
                          }}
                        >
                          <Stack sx={{ minWidth: "150px" }}>
                            <Typography className={classes.input_label}>
                              Year
                            </Typography>
                          </Stack>
                          <Stack>
                            <TextField
                              id="year"
                              name="year"
                              placeholder="Enter year"
                              type="number"
                              sx={{
                                width: 220,
                              }}
                              className={
                                errors.year && touched.year
                                  ? classes.inputError
                                  : classes.inputNoError
                              }
                              onChange={handleChange}
                              value={values.year}
                            />
                            <ErrorMessage
                              name="year"
                              component="span"
                              className={classes.error}
                            />
                          </Stack>
                        </Stack>
                        <Stack
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "row",
                            ml: 1,
                          }}
                        >
                          <Stack sx={{ minWidth: "150px" }}>
                            <Typography className={classes.input_label}>
                              Semester
                            </Typography>
                          </Stack>
                          <Stack>
                            <Select
                              id="idSemester"
                              name="idSemester"
                              placeholder="Choose Semester"
                              onChange={handleChange}
                              IconComponent={CustomExpandMore}
                              className={
                                errors.idSemester && touched.idSemester
                                  ? classes.inputError
                                  : classes.inputNoError
                              }
                              sx={{
                                width: 220,
                              }}
                              value={values.idSemester}
                              displayEmpty
                            >
                              <MenuItem value="">Select Semester</MenuItem>
                              
                              {semesterData?.map((_el, index) => (
                                <MenuItem value={_el.id} key={index}>
                                  {_el.name}
                                </MenuItem>
                              ))}
                            </Select>
                            <ErrorMessage
                              name="idSemester"
                              component="span"
                              className={classes.error}
                            />
                          </Stack>
                        </Stack>
                      </Stack>
                    </Grid>
                    <Stack style={{ flexDirection: "row" }}>
                      <Stack>
                        <Typography className={classes.input_label}>
                          Description
                        </Typography>
                      </Stack>
                      <Stack>
                        <TextField
                          id="description"
                          name="description"
                          placeholder="Enter Description"
                          multiline
                          rows={4}
                          sx={(theme) => ({
                            [theme.breakpoints.down(1359)]: {
                              minWidth: 600,
                            },
                            [theme.breakpoints.down(884)]: {
                              minWidth: 350,
                            },
                            minWidth: 620,
                            marginLeft: "55px",
                          })}
                          className={
                            errors.description && touched.description
                              ? classes.inputError
                              : classes.inputNoError
                          }
                          type="text"
                          onChange={handleChange}
                          value={values.description}
                        />
                        <Button
                          type="submit"
                          sx={(theme) => ({
                            px: 1,
                            py: 2,
                            my: 2,
                            borderRadius: "50px",
                            fontSize: "15px",
                            [theme.breakpoints.down(1359)]: {
                              minWidth: 500,
                            },
                            [theme.breakpoints.down(884)]: {
                              minWidth: 350,
                            },
                            minWidth: 620,
                            ml: "3.9rem",
                            "& :hover": {
                              background: `${color.lightGreen} !important`,
                              color: `${color.white} !important`,
                            },
                          })}
                          className={classes.submit_btn}
                          onClick={handleClick}
                        >
                          {id ? "Save Subject" : "Add Subject"}
                        </Button>
                        <Button
                          type="button"
                          sx={(theme) => ({
                            px: 1,
                            py: 2,
                            my: 2,
                            borderRadius: "50px",
                            fontSize: "15px",
                            [theme.breakpoints.down(1359)]: {
                              minWidth: 500,
                            },
                            [theme.breakpoints.down(884)]: {
                              minWidth: 350,
                            },
                            minWidth: 620,
                            ml: "3.9rem",
                            background: "#EAECF0 !important",
                            color: `#979797 !important`,
                            textTransform: "capitalize !important",
                            "&:hover": {
                              background: "#EAECF0 !important",
                              color: `#979797 !important`,
                            },
                          })}
                          onClick={() => navigate(-1)}
                        >
                          Cancel
                        </Button>
                      </Stack>
                    </Stack>
                  </form>
                );
              }}
            </Formik>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};

export default AddEditSubject;
